import React from 'react'
import { useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import Header from 'redesign/components/organisms/Header'
import AbsenceAcceptDetailsFooter from 'redesign/components/organisms/absence-accept-details-footer'
import { TASK_DETAILS_PAGE_ROOT_ID } from 'redesign/pages/task-details/constants'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import Page from '../Page'
import AbsenceAcceptContent from '../absence-accept-content'
import type { AbsenceAcceptDetailsProps } from './types'
import { useAcceptForm } from './use-accept-form'

const AbsenceAcceptDetails: React.FC<AbsenceAcceptDetailsProps> = ({ onGoBack, task, timelineItems, refetch }) => {
  const { palette } = useTheme()
  const { t } = useFavurTranslation()

  const onAccept = () => {
    refetch()
    onGoBack()
  }

  const {
    loading,
    diffDaysSwitchProps,
    absenceTypeSelectProps,
    onSubmit,
    showDiffDaysToggle,
    showSingleTypeField,
    taskCommentFieldProps,
    mirusCommentFieldProps,
    individualAbsenceTypeFieldsProps,
  } = useAcceptForm({
    onAccept,
    task,
  })

  return (
    <Page
      hideNativeNavigation
      removeLastMargin
      rootId={TASK_DETAILS_PAGE_ROOT_ID}
      fullContentHeight
      paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
      header={
        <Header
          startContent={<BackButton onGoBack={onGoBack} />}
          middleContent={<HeaderLabel mainText={t('absenceRequest.accept.title')} />}
        />
      }
      footer={loading ? undefined : <AbsenceAcceptDetailsFooter onSubmit={onSubmit} task={task} />}
      backgroundColor={palette.background.base}
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <AbsenceAcceptContent
          task={task}
          timelineItems={timelineItems}
          diffDaysSwitchProps={diffDaysSwitchProps}
          absenceTypeSelectProps={absenceTypeSelectProps}
          showDiffDaysToggle={showDiffDaysToggle}
          showSingleTypeField={showSingleTypeField}
          taskCommentFieldProps={taskCommentFieldProps}
          mirusCommentFieldProps={mirusCommentFieldProps}
          individualAbsenceTypeFieldsProps={individualAbsenceTypeFieldsProps}
        />
      )}
    </Page>
  )
}

export default AbsenceAcceptDetails
